export const NO_SALARY_ADVICE = 'NO_SALARY_ADVICE';

export type NoSalaryAdvice = typeof NO_SALARY_ADVICE;
